import { useHistory } from 'react-router-dom'
import { APP_AUTH, getStore, removeStore } from 'src/utils/auth'

const useRedirectAfterLogin = () => {
  const history = useHistory()
  return ({ redirectUrl = '/' }) => {
    try {
      let path = getStore(APP_AUTH.REDIRECT_AFTER_SIGNIN)
      removeStore(APP_AUTH.REDIRECT_AFTER_SIGNIN)
      return path ? history.goBack() : history.replace(redirectUrl)
    } catch (error) {
      console.log('Get local storage path error:', error)
      return history.push(redirectUrl)
    }
  }
}

export default useRedirectAfterLogin
